// Símbolo do Hexis AI — hexágono + núcleo + órbita. Trivial e estável; fica no
// design-system de cada app (o packages/shared é propositadamente SEM React).
// Mantido idêntico ao da consola HQ (apps/admin/src/shell/HexisSymbol.tsx).
export function HexisSymbol({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false">
      <path d="M16 2L28 9v14l-12 7L4 23V9l12-7z" fill="url(#hg)" fillOpacity="0.15" stroke="url(#hg)" strokeWidth="1.5" />
      <circle cx="16" cy="16" r="4" fill="url(#hg)" />
      <path d="M16 8v4M16 20v4M10.3 11l3.5 2M18.2 19l3.5 2M10.3 21l3.5-2M18.2 13l3.5-2" stroke="var(--purple-50)" strokeWidth="1.2" strokeLinecap="round" />
      <defs><linearGradient id="hg" x1="4" y1="2" x2="28" y2="30"><stop stopColor="var(--purple)" /><stop offset="1" stopColor="var(--purple-50)" /></linearGradient></defs>
    </svg>
  );
}
